import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutsModule } from 'src/app/layouts/layouts.module';
import { DashboardComponent } from './main/dashboard.component';
import { AuthGuard } from '@app/components/cleanui/system/Guard/auth.guard';

// dashboard
const routes: Routes = [
	{
		path: '',
		component: DashboardComponent,
		data: { title: 'Dashboard' },
		canActivate: [AuthGuard],
	}
];

@NgModule({
	imports: [LayoutsModule, RouterModule.forChild(routes)],
	providers: [],
	exports: [RouterModule]
})
export class DashboardRouterModule {}
